module.exports = __webpack_public_path__ + "media/images/riders/small/MIRANDA_MILLER-147799428e88220873d511ce8323ac0c.png";